/*
 Export intercom id:s for elements to be targeted by
 */
export const INTERCOM_IDS = {
  MAIN_MENU_USER: "main-menu-user",
  MAIN_MENU_ALERTS: "main-nav-link-alerts",
  MAIN_MENU_ALERT_SETTINGS: "main-nav-active-alert-settings",
  MAIN_MENU_EXPLORE: "main-nav-link-explore",
  MAIN_MENU_REPORTS: "main-nav-link-analytics",
  MAIN_MENU_TAGS: "main-nav-link-tags",
  MAIN_MENU_ARCHIVE: "main-nav-link-archive",
  MAIN_MENU_FAVORITES: "main-nav-link-favorites",
  MAIN_MENU_CREATE_NEW: "main-nav-link-new-alert",
};
